// extracted by mini-css-extract-plugin
module.exports = {"container":"AvailabilityIndicator_container__hGJ4E","banner":"AvailabilityIndicator_banner__OS2De"};